module.exports = __webpack_public_path__ + "img/38.72b24e4a.png";